<template>
  <page-container>
    <heading size="gigantic">Tags</heading>

    <b-message v-if="!hasTags">Seems like you don't have any tags.</b-message>

    <div v-else>
      <div class="controls flex justify-between">
        <b-field>
          <b-dropdown animation="pop" v-model="displayMode">
            <b-button
              class="button has-equal-padding"
              slot="trigger"
              native-value="all"
            >
              <nice-icon icon="user" spacing-right></nice-icon>
              <span>Personal tags</span>
              <nice-icon type="fas" icon="caret-down"></nice-icon>
            </b-button>

            <b-dropdown-item value="personal" aria-role="listitem">
              <nice-icon icon="user" spacing-right></nice-icon>
              <span>Personal tags</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-field>

        <div>
          <b-field>
            <p class="control">
              <b-button
                class="has-equal-padding"
                @click="isReversed = !isReversed"
              >
                <nice-icon
                  type="fad"
                  :icon="`sort-${!isReversed ? 'up' : 'down'}`"
                ></nice-icon>
              </b-button>
            </p>
            <p class="control">
              <b-dropdown
                animation="pop"
                v-model="sortMode"
                position="is-bottom-left"
              >
                <button
                  class="button is-primary has-equal-padding"
                  type="button"
                  slot="trigger"
                >
                  <nice-icon
                    :icon="sortModes[sortMode].icon"
                    spacing-right
                  ></nice-icon>
                  <span>{{ sortModes[sortMode].label }}</span>
                  <nice-icon type="fas" icon="caret-down"></nice-icon>
                </button>

                <b-dropdown-item value="date" aria-role="listitem">
                  <nice-icon icon="clock" spacing-right></nice-icon>
                  <span>Date created</span>
                </b-dropdown-item>
                <!-- <hr class="dropdown-divider" /> -->
                <b-dropdown-item value="alphabetic" aria-role="listitem">
                  <nice-icon icon="sort-alpha-down" spacing-right></nice-icon>
                  <span>Alphabetic</span>
                </b-dropdown-item>
                <!-- <hr class="dropdown-divider" /> -->
                <b-dropdown-item value="count" aria-role="listitem">
                  <nice-icon icon="sort-numeric-down" spacing-right></nice-icon>
                  <span>Resource count</span>
                </b-dropdown-item>
              </b-dropdown>
            </p>
          </b-field>
        </div>
      </div>

      <b-field class="mt3" label="Filter tags">
        <b-input
          v-model="searchtextComputed"
          class="search"
          autofocus
          placeholder="Type to filter..."
          :loading="isFiltering"
          @input="isFiltering = true"
        ></b-input>
      </b-field>

      <div class="timeline">
        <!-- <header class="timeline-header">
        <span class="tag is-medium is-primary">Start</span>
        </header>-->

        <div
          class="timeline-item"
          v-for="key in sortedGroupKeys"
          :key="`group-${key}`"
        >
          <!-- <div class="timeline-marker is-icon">{{ group.length }}</div> -->
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading f4" @click="onHeadingClick(key)">
              {{
                sortMode === "date" ? new Date(key).toLocaleDateString() : key
              }}
              <nice-icon
                icon="ellipsis-h"
                v-show="hiddenTimelineItems[key]"
              ></nice-icon>
            </p>
            <!-- <b-taglist v-show="!hiddenTimelineItems[key]" class="taglist">
            <tag-item
              v-for="(tag, index) in group"
              :key="index"
              show-resources-count
              :tag="tag"
              :class="{
                'is-contexted': contextedTag && contextedTag.id == tag.id
              }"
              @click="onTagClick(tag)"
              @contextmenu.native.prevent="openContextMenu($event, tag)"
            >
              {{ tag.text }}
            </tag-item>
            </b-taglist>-->

            <tag-list
              v-show="!hiddenTimelineItems[key]"
              :tags="groupedTags[key]"
              @tagClicked="onTagClick"
              :context-options="{ userIsOwner: true, preventRemove: true, preventSearchAdd: true }"
            ></tag-list>

            <!-- <tag-list
              v-show="!hiddenTimelineItems[key]"
              class="taglist"
              :use="groupedTags[key]"
              :show-all="true"
              :limit-height="false"
              :can-load-more="false"
              :filterable="false"
              @tagClicked="onTagClick"
              can-share
              :show-context-divider="false"
              :tag-props="{
                showResourcesCount: true
              }"
              :context="currentContext"
            ></tag-list> -->
          </div>
        </div>

        <!-- <div class="timeline-header">
        <span class="tag is-medium is-primary">End</span>
        </div>-->
      </div>
    </div>
  </page-container>
</template>

<script>
import TagList from "@/shared/components/tag/SimpleList";
import debounce from "lodash/debounce";

export default {
  data() {
    return {
      displayMode: "personal",
      sortMode: "date",
      isReversed: true,

      isFiltering: false,

      sortModes: {
        date: {
          icon: "clock",
          label: "Date added"
        },
        alphabetic: {
          icon: "sort-alpha-down",
          label: "Alphabetic"
        },
        count: {
          icon: "sort-numeric-down",
          label: "Resource count"
        }
      },

      hiddenTimelineItems: {},
      searchtext: "",
      contextedTag: null
    };
  },

  methods: {
    onHeadingClick(key) {
      if (this.hiddenTimelineItems[key]) {
        this.$delete(this.hiddenTimelineItems, key);
      } else {
        this.$set(this.hiddenTimelineItems, key, true);
      }
    },

    onTagClick(tag) {
      this.$router.push({ name: "own.resources", query: { tags: tag.id } });
    }
  },

  computed: {
    searchtextComputed: {
      get() {
        return this.searchtext;
      },
      set: debounce(function(newValue) {
        this.searchtext = newValue;
      }, 200)
    },

    hasTags() {
      return this.tagsArray.length > 0;
    },

    tagsArray() {
      return this.$store.getters[`${this.currentContext}/tagsArray`];
    },

    filteredTags() {
      let tagsFiltered = this.tagsArray;

      if (this.searchtext.length > 1) {
        const searchLower = this.searchtext.toLowerCase();
        tagsFiltered = this.tagsArray.filter(t =>
          t.text.toLowerCase().includes(searchLower)
        );
      }

      return tagsFiltered;
    },

    groupedTags() {
      let tagsGrouped = this.filteredTags;
      if (!tagsGrouped) return false;

      switch (this.sortMode) {
        case "date":
          tagsGrouped = this.$utils.groupBy(
            tagsGrouped,
            t => t.created_at.split(" ")[0]
          );
          break;

        case "alphabetic":
          tagsGrouped = this.$utils.groupBy(
            tagsGrouped,
            t => t.text && t.text.charAt(0).toLowerCase()
          );
          break;

        case "count":
          tagsGrouped = this.$utils.groupBy(
            tagsGrouped,
            t => t.resources_count
          );
          break;
      }

      return tagsGrouped;
    },

    sortedGroupKeys() {
      if (!this.groupedTags) return false;
      let tagKeysSorted = Object.keys(this.groupedTags);

      switch (this.sortMode) {
        case "date":
          tagKeysSorted.sort();
          if (this.isReversed) {
            tagKeysSorted.reverse();
          }
          break;

        case "alphabetic":
          tagKeysSorted.sort();
          if (!this.isReversed) {
            tagKeysSorted.reverse();
          }
          break;

        case "count":
          tagKeysSorted.sort((a, b) => a - b);
          if (this.isReversed) {
            tagKeysSorted.reverse();
          }
          break;
      }

      setTimeout(() => {
        this.isFiltering = false;
      }, 250);

      return tagKeysSorted;
    }
  },

  components: {
    TagList
  }
};
</script>

<style lang="scss" scoped>
@import "~bulma-timeline";

.timeline {
  .timeline-item {
    padding-bottom: 0;

    &:before {
      background-color: $light_05;
    }

    .taglist {
      padding-bottom: 20px;
    }
  }
  .timeline-marker {
    background-color: $light_10 !important;
    border-color: $light_10 !important;
    color: $light_40;
  }

  .heading {
    font-size: 16px;
    color: $light_20;
    cursor: pointer;
    user-select: none;
    padding-top: 7px;

    &:hover {
      color: $light_40;
    }
  }

  .timeline-content {
    padding-top: 7px !important;
  }
}
</style>

<style lang="scss">
.search {
  .input {
    font-size: 20px !important;
  }
}
</style>
